const DEV = window.location.hostname === "localhost";
if (DEV)
    console.log("Running in dev mode.");
export default {
    DEV
};
